export const guidelines = [
  {
    id: 'min-length',
    label: 'Mínimo de 8 caracteres',
    test: (value: string) => value.length >= 8,
  },
  {
    id: 'has-number',
    label: 'Mínimo 1 número',
    test: (value: string) => /\d/.test(value),
  },
  {
    id: 'has-uppercase',
    label: 'Mínimo 1 letra maiúscula',
    test: (value: string) => /[A-Z]/.test(value),
  },
  {
    id: 'has-lowercase',
    label: 'Mínimo 1 letra minúscula',
    test: (value: string) => /[a-z]/.test(value),
  },
  {
    id: 'has-special',
    label: 'Mínimo 1 caractere especial (@*!%;:.)',
    test: (value: string) => /[!-/:-@[-`{-~]/.test(value),
  },
  {
    id: 'passwords-match',
    label: 'Campos “Senha” e “Confirmação de senha” devem ser idênticos',
    test: (value: string, confirmation: string) =>
      !!value?.length && !!confirmation?.length && confirmation === value,
  },
]
